import { render } from "./comprobante.vue?vue&type=template&id=ef4695a2&scoped=true"
import script from "./comprobante.vue?vue&type=script&lang=js"
export * from "./comprobante.vue?vue&type=script&lang=js"

import "./comprobante.vue?vue&type=style&index=0&id=ef4695a2&scoped=true&lang=css"

import exportComponent from "E:\\Proyectos\\Front_IOSEP\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef4695a2"]])

export default __exports__